// extracted by mini-css-extract-plugin
export default {"container":"F5_0gDExIpFFeo3n8SxA","checkboxContainer":"PiefKGITB17LccpEtf2x","checkbox":"SaTMu_HfehxA_lIpuWhg","label":"T27jhZfV3KtGZlRhsGRl"};